module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sp-top-header padding-top-10 padding-bottom-10 padding-left-10"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._m(1), _vm._v(" "), (_vm.sellpoint.business_name != undefined) ? _c('a', {
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("| "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-mobile-menu"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.edit_mode) ? _c('span', {}, [_c('h6', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Shop Information")]), _vm._v(" "), (_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spMessagesPanel', '')
      }
    }
  }, [_vm._v("Messages")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#notificationsModal"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('', '')
      }
    }
  }, [_vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spOrdersPanel', '')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Shop Settings")])])]) : _vm._e()]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "pull-right sp-menu-left-bar"
  }, [_c('menu-left-bar')], 1)]), _vm._v(" "), _c('h1', [_vm._v("Dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "sp-shop-menu-section",
    attrs: {
      "id": "menuHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row sp-shop-menu-horizontal"
  }, [_c('ul', {}, [(!_vm.edit_mode) ? _c('span', _vm._l((_vm.sellpoint.business_categories), function(cat, count) {
    return _c('li', [(count < 5) ? _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat.business_category_id)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProfilePanel', '')
      }
    }
  }, [_vm._v("About Us")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spContactPanel', '')
      }
    }
  }, [_vm._v("Contact Us")])]), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 0) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("My Shop")])]) : _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("Shop "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content shop-dropdown-content",
    attrs: {
      "id": "shop-dropdown-content"
    }
  }, _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat.business_category_id)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")])])
  }))]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spServicesPanel', '')
      }
    }
  }, [_vm._v("Services")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spBlogPanel', '')
      }
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spGalleryPanel', '')
      }
    }
  }, [_vm._v("Gallery")])]), _vm._v(" "), (_vm.edit_mode) ? _c('span', {
    staticClass: "sp-specific-menu"
  }, [(_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spMessagesPanel', '')
      }
    }
  }, [_vm._v("Messages")])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spOrdersPanel', '')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Shop Settings")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "hidden-lg hidden-md sp-action-display-menu",
    staticStyle: {
      "margin-left": "2em",
      "margin-right": "4em",
      "display": "none"
    },
    attrs: {
      "id": "product-action-display-menu"
    }
  }, [_c('ul', {}, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Search"
    },
    on: {
      "click": function($event) {
        _vm.showSectionById('searchSection')
      }
    }
  }, [_vm._v("Sort By "), _c('i', {
    staticClass: "fa fa-sort-down",
    staticStyle: {
      "padding-left": "5px",
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content sort-dropdown-content",
    attrs: {
      "id": "sort-dropdown-content"
    }
  }, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Featured")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Orders Made")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Discounted")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Pre-Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (Low to High)")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (High to Low)")])])])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "filter"
    },
    on: {
      "click": function($event) {
        _vm.showSectionById('filterSection')
      }
    }
  }, [_vm._v("Filter Items")])])])])])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "sp-body",
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-5 padding-bottom-100",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.addProductPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Shop")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('product-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addPostPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Sellpoint")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-post-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addGalleryPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Sellpoint")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-gallery-form')], 1)]) : _vm._e(), _vm._v(" "), (_vm.addProductGalleryPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('sellpoint-panel', '')
      }
    }
  }, [_vm._v(" << Back to Sellpoint")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-4"
  }, [_c('new-product-gallery-form')], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-sm-3 sp-side",
    attrs: {
      "id": "spSidebar"
    }
  }, [_c('div', {
    staticClass: "shop-sidebar"
  }, [(_vm.can_edit) ? _c('div', {
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "sp-sidebar-sort-filter"
  }, [_c('h5', {
    staticClass: "shop-tittle margin-bottom-10"
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Featured")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Orders Made")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Discounted")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Pre-Orders")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (Low to High)")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price (High to Low)")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.edit_mode) ? _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("My Sellpoint Shop Categories")]) : _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("Take a pick")]), _vm._v(" "), (_vm.category.edit) ? _c('div', [_c('h6', [_vm._v("Edit Category")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.business_category),
      expression: "category.business_category"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.category.business_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.business_category = $event.target.value
      }
    }
  }), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": _vm.editCategory
    }
  }, [_c('i', {
    staticClass: "icon-check"
  })])]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit-category', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  })])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_categories) ? _c('ul', {}, _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('li', {
      staticStyle: {
        "padding": "5px",
        "border-bottom": "1px solid #d1d5db"
      }
    }, [_c('p', [_c('span', {
      staticClass: "a-lf"
    }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getCategoryProducts(cat.business_category_id)
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")]), _vm._v(" "), (_vm.edit_mode) ? _c('span', [(cat.can_edit == 1) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.setComponent('edit-category', cat)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]) : _vm._e()]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "sp-add-new-category",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "color": "#363535"
    }
  }, [_vm._v("Add New Category > ")]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Select from related category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_category),
      expression: "category.new_category"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "30px",
      "width": "245px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.category.new_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(ct) {
    return _c('option', {
      domProps: {
        "value": ct.sub_category_id
      }
    }, [_vm._v(_vm._s(ct.sub_category_name))])
  })], 2)]), _vm._v(" "), _c('b', [_vm._v("OR")]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.new_listed_category),
      expression: "category.new_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Category"
    },
    domProps: {
      "value": (_vm.category.new_listed_category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.category.new_listed_category = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2",
      "font-size": "12px",
      "margin-top": "1em"
    },
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("Add Category")])])]) : _vm._e()]) : _c('div', [(_vm.edit_mode) ? _c('h5', {
    staticClass: "shop-tittle margin-bottom-30"
  }, [_vm._v("My Market Categories")]) : _vm._e(), _vm._v(" "), _c('ul', {}, _vm._l((_vm.sellpoint.business_market_categories), function(cat) {
    return _c('li', {
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('p', [_c('span', {
      staticClass: "a-lf"
    }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getSellpointMarketProducts()
        }
      }
    }, [_vm._v(_vm._s(cat.business_category) + " ")])]), _vm._v(" "), _c('ul', {}, _vm._l((cat.business_sub_categories), function(sub_cat) {
      return _c('li', {
        staticStyle: {
          "padding": "5px",
          "border-bottom": "1px solid #e5eaf0"
        }
      }, [_c('p', [_c('span', {
        staticClass: "a-lf"
      }, [_vm._v(" > ")]), _vm._v(" "), _c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.getCategoryProducts(sub_cat.business_sub_category_id)
          }
        }
      }, [_vm._v(_vm._s(sub_cat.business_sub_category) + " ")])])])
    }))])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card col-sm-8 sp-main",
    attrs: {
      "id": "spMain"
    }
  }, [(_vm.sellpoint.business_market_category_id == 2) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "create?create=new"
    }
  }, [_vm._v("Add New Sellpoint")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 3) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "create?create=add"
    }
  }, [_vm._v("Add New Business")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewAllProductsBanner) ? _c('div', {
    staticClass: "col-xs-6",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('view-all-products', '')
      }
    }
  }, [_vm._v("\r\n                View all Products")])]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.spProductsPanel) ? _c('div', [(_vm.spMarketPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.market), function(sp) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      staticClass: "img-1 img-responsive",
      attrs: {
        "src": _vm.img_sellpoint_url + sp.business_brand_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-name"
    }, [_c('p', {
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      attrs: {
        "href": sp.business_username
      }
    }, [_vm._v(_vm._s(sp.business_name))])])])])])])])
  })) : _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "item-display hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-product', '')
      }
    }
  }, [_vm._v("Add New Product")])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row filter-sort-board",
    attrs: {
      "id": "filterSortBoard"
    }
  }, [_c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "reset-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.toggleFilterSortBoard()
      }
    }
  }, [_vm._v("Hide")]), _vm._v(" "), _c('a', {
    staticClass: "reset-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.resetFilterSortOptions()
      }
    }
  }, [_vm._v("Reset Options")])]), _vm._v(" "), (_vm.price_filter_is_set) ? _c('div', {
    staticStyle: {
      "width": "45%",
      "padding-bottom": "1em",
      "margin-bottom": "6px",
      "border-bottom": "1px solid #f2f2f2"
    }
  }, [_c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Price")]), _vm._v(" "), _c('vue-slider', _vm._b({
    model: {
      value: (_vm.slider_type),
      callback: function($$v) {
        _vm.slider_type = $$v
      },
      expression: "slider_type"
    }
  }, 'vue-slider', _vm.slider_options, false)), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "8px"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("FILTER")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "p-tiny"
  }, [_vm._v("Sort Items by")]), _vm._v(" "), _c('div', {
    staticClass: "sort-row"
  }, [_c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Featured")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Orders")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Newest")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Discounted")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Pre-Orders")]), _vm._v(" "), _c('a', {
    staticClass: "sort-by",
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.filterByPrice()
      }
    }
  }, [_vm._v("Price\r\n                                "), _vm._m(11), _vm._v(" "), _vm._m(12)])])])])]), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "hidden-md hidden-lg",
    staticStyle: {
      "margin-top": "1.3em"
    }
  }, [(_vm.sellpoint.business_market_category_id == 1) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-product', '')
      }
    }
  }, [_vm._v("Add New Product")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row fixed-pan-03"
  }, [(_vm.products.length > 0) ? _c('div', {}, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.listView) ? _c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('market-view', '')
      }
    }
  }, [_vm._v("\r\n                        Switch to Market View")])]) : _vm._e(), _vm._v(" "), (_vm.marketView) ? _c('span', {
    staticClass: "product-num"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('list-view', '')
      }
    }
  }, [_vm._v("\r\n                        Switch to List View")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "reset-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "showFilters",
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.toggleFilterSortBoard()
      }
    }
  }, [_vm._v("Filter Items")])])])]) : _vm._e(), _vm._v(" "), (!_vm.products.length) ? _c('span', [_c('p', [_vm._v("No Products added yet")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:start",
      value: (_vm.mouseover),
      expression: "mouseover",
      arg: "start"
    }],
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [(_vm.listView) ? _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-6 sp-prd-col-wrap"
    }, [_c('div', {
      staticClass: "sp-prd-col"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "item"
      }, [(index2 == 0) ? _c('div', [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [(product.product_images[0]) ? _c('div', {
        staticClass: "item-img sp-prd-list-img"
      }, [_c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": product.product_images[0].product_image,
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "img-2 sp-prd-img",
        attrs: {
          "src": product.product_images[0].product_image,
          "alt": ""
        }
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "item-name"
      }, [_c('div', {
        staticClass: "sp-prd-name"
      }, [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_item_price))])])])]) : _vm._e()])
    }))])
  })) : _vm._e(), _vm._v(" "), (_vm.marketView) ? _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "shop-detail"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "row"
      }, [(index2 == 0) ? _c('div', {
        staticClass: "col-md-8 col-md-offset-2"
      }, [_c('h4', [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "img-1",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _vm._m(13, true), _vm._v(" "), _c('ul', {
        staticClass: "item-owner"
      }, [_c('li', [_vm._v("Tagged By :"), _c('span', [_vm._v(" " + _vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('li', [_vm._v("Category:"), _c('span', [_vm._v(" " + _vm._s(product.product_category_name))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.product_description))]), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()])
    }))
  })) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.spBlogPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [(_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-post', '')
      }
    }
  }, [_vm._v("+ New Blog")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      staticClass: "shop-detail"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 col-md-offset-2"
    }, [_c('h4', [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/' + post.post_url_name
      }
    }, [_vm._v(_vm._s(post.post_title))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_ownername))]), _vm._v(" "), _vm._l((post.post_media), function(post_media) {
      return _c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": post_media,
          "alt": ""
        }
      })])
    }), _vm._v(" "), _vm._m(14, true), _vm._v(" "), _c('ul', {
      staticClass: "item-owner"
    }, [_c('li', [_c('span', [_vm._v(" " + _vm._s(post.post_time_ago))])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.post_text))]), _vm._v(" "), _c('br'), _c('br')], 2)])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spServicesPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [_c('div', {
    staticClass: "papular-block row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-6 sp-prd-col-wrap"
    }, [_c('div', {
      staticClass: "sp-prd-col"
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "item"
      }, [(index2 == 0) ? _c('div', [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_c('div', {
        staticClass: "item-img sp-prd-list-img"
      }, [_c('img', {
        staticClass: "img-1 sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "img-2 sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "item-name"
      }, [_c('div', {
        staticClass: "sp-prd-name"
      }, [_c('a', {
        attrs: {
          "href": _vm.sellpoint.business_username + '/' + product.product_url_name
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', {
        staticClass: "sp-prd-descr"
      }, [_vm._v(_vm._s(product.product_description))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.product_category_name))])]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(product_item.product_item_price))])])]) : _vm._e()])
    }))])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spGalleryPanel) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.sellpoint.business_market_category_id == 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-gallery', '')
      }
    }
  }, [_vm._v("+ New Lookbook")])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('add-product-gallery', '')
      }
    }
  }, [_vm._v("+ New Product Lookbook")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "productlist"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.galleria), function(gallery) {
    return _c('div', {
      staticClass: "col-md-3 col-xs-6"
    }, [_c('div', {}, [_c('a', {
      attrs: {
        "href": _vm.sellpoint.business_username + '/g/' + gallery.gallery_posts_group_url_name
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-img sp-prd-list-img",
      staticStyle: {
        "height": "220px"
      }
    }, [_c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0],
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img-2 sp-prd-img",
      attrs: {
        "src": _vm.img_product_url + _vm.product_item.product_item_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(gallery.gallery_posts_group_name))])])])])])
  }))])])])]) : _vm._e(), _vm._v(" "), (_vm.spProfilePanel) ? _c('div', {
    attrs: {
      "id": "sp-profile"
    }
  }, [_c('div', {
    staticClass: "history-block padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-9 sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-5 sp-pl0"
  }, [(_vm.details.tagline_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Enter Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('tagline')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v(" submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_tagline) ? _c('span', [_c('h2', [_vm._v(_vm._s(_vm.sellpoint.business_tagline) + "\r\n                                "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-tagline', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e()])]) : _c('span', [_c('h2', [_vm._v("Connect with me, through my Sellpoint\r\n                                "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-tagline', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-50"
  }, [_c('img', {
    staticClass: "img_responsive",
    attrs: {
      "src": _vm.img_sellpoint_url + _vm.sellpoint.business_brand_image,
      "width": "250",
      "height": "250"
    }
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Change Brand Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'business_brand_image')
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 margin-top-50 sp-pl0"
  }, [(_vm.details.profile_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Your Business Profile")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('profile')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_profile) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_profile) + "\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-profile', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("Making Business memories as exciting as fireworks display, on a New Year's Sky.\r\n                                    Having an online presence is crucial as it helps me connect with my customers irrespective of their location\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-profile', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sp-profile-services"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h6', [_vm._v("My Services")]), _vm._v(" "), (_vm.edit_mode) ? _c('ul', _vm._l((_vm.sellpoint.business_services), function(service) {
    return _c('li', [(service.edit_set) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.business_service),
        expression: "service.business_service"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (service.business_service)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          service.business_service = $event.target.value
        }
      }
    }), _vm._v(" "), _c('button', {
      attrs: {
        "type": "submit"
      },
      on: {
        "click": _vm.editService
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })])]) : _c('p', [_vm._v(_vm._s(service.business_service) + " "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-service', service)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })])])])
  })) : _c('ul', _vm._l((_vm.sellpoint.business_services), function(service) {
    return _c('li', [_c('p', [_vm._v(_vm._s(service.business_service))])])
  })), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.service_name),
      expression: "service.service_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter a service"
    },
    domProps: {
      "value": (_vm.service.service_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.service.service_name = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addService
    }
  }, [_vm._v("Add a Service")])]) : _vm._e()])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spContactPanel) ? _c('div', {
    attrs: {
      "id": "sp-contact"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block  sp-pl0"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form  sp-pl0"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12 sp-pl0",
    staticStyle: {
      "border": "1.5px rgb(16, 5, 82) solid",
      "padding": "4em",
      "min-height": "30em"
    }
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Contact Information")]), _vm._v(" "), (_vm.details.contact_info_edit) ? _c('div', {
    staticClass: "contact_form sp-pl0"
  }, [(_vm.edit_mode) ? _c('ul', {}, [_c('li', [_c('label', [_vm._v("Address\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Email(s)\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Phone(s)\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('contact_info')
      }
    }
  }, [_c('i', {
    staticClass: "icon-file"
  }), _vm._v("Save")]), _vm._v("\r\n                                        \r\n                                  "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])]) : _c('div', [(_vm.sellpoint.business_address) ? _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]) : _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_emails) ? _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]) : _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_phones) ? _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]) : _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.edit_mode) ? _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-contact-info', '')
      }
    }
  }, [_vm._v("Edit Details")]) : _vm._e()])]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "col-sm-4 contact_form"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("SEND A MESSAGE")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *NAME ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.name),
      expression: "contact_form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *EMAIL\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.email),
      expression: "contact_form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR MESSAGE"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.message),
      expression: "contact_form.message"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": (_vm.contact_form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-left no-margin",
    on: {
      "click": _vm.sendBusinessContactForm
    }
  }, [_vm._v("SEND MESSAGE")])])])])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spMessagesPanel) ? _c('div', {
    attrs: {
      "id": "sp-messages"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12",
    staticStyle: {
      "border": "1.5px rgb(16, 5, 82) solid",
      "padding": "4em",
      "min-height": "30em"
    }
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Your Messages")]), _vm._v(" "), (_vm.details.contact_info_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', [_c('label', [_vm._v("Address\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Email(s)\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Phone(s)\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('contact_info')
      }
    }
  }, [_c('i', {
    staticClass: "icon-file"
  }), _vm._v("Save")]), _vm._v("\r\n                                      \r\n                                "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])]) : _c('div', [(_vm.sellpoint.business_address) ? _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v(_vm._s(_vm.sellpoint.business_address))]) : _c('p', [_c('b', [_vm._v("Address: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_emails) ? _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))]) : _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v("No details yet")]), _vm._v(" "), (_vm.sellpoint.business_phones) ? _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))]) : _c('p', [_c('b', [_vm._v("Phones: ")]), _vm._v("No details yet")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-contact-info', '')
      }
    }
  }, [_vm._v("Edit Details")])])]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "col-sm-4 contact_form"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("SEND A MESSAGE")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *NAME ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.name),
      expression: "contact_form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *EMAIL\r\n                                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.email),
      expression: "contact_form.email"
    }],
    attrs: {
      "type": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.contact_form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR MESSAGE"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact_form.message),
      expression: "contact_form.message"
    }],
    domProps: {
      "value": (_vm.contact_form.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact_form.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-left no-margin",
    on: {
      "click": _vm.sendBusinessContactForm
    }
  }, [_vm._v("SEND MESSAGE")])])])])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spOrdersPanel) ? _c('div', {
    attrs: {
      "id": "sp-orders"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block"
  }, [_c('div', {
    staticClass: "vision-text col-md-12 contact_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Orders on " + _vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "overflow": "scroll"
    }
  }, [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Order From")]), _vm._v(" "), _c('th', [_vm._v("Order Total")]), _vm._v(" "), _c('th', [_vm._v("Payment Mode")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#2d3a4b"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(order.order_no))])]), _c('br'), _vm._v("\r\n                                    " + _vm._s(order.order_date) + "\r\n                                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_business))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spDeliveryPanel) ? _c('div', {
    attrs: {
      "id": "sp-delivery"
    }
  }, [_c('div', {
    staticClass: "history-block padding-top-50 padding-bottom-100 col-sm-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block .sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-8 sp-pl0"
  }, [(_vm.edit_mode) ? _c('h6', [_vm._v("Your Sellpoint's Delivery Information")]) : _c('h6', [_vm._v("General Delivery Information")]), _vm._v(" "), (_vm.details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('li', [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "icon-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information) + "\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-delivery-information', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                                      Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                                      partners to make transactions seamless.\r\n                                    "), (_vm.edit_mode) ? _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-delivery-information', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sp-profile-services"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [_c('div', [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.editDeliveryInformation && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('li', [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('li', [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('reset-delivery-information', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                                              " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                                              "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "icon-close"
    })])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-delivery-information', '')
      }
    }
  }, [_vm._v("Add New Delivery Information")]), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.addDeliveryInformation) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('li', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('li', [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('li', [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-delivery-information', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]) : _c('div', [_c('ul', _vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('li', [_c('p', [_vm._v(_vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price))])])
  }))])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.spSettingsPanel) ? _c('div', {
    attrs: {
      "id": "sp-contact"
    }
  }, [_c('div', {
    staticClass: "history-block padding-bottom-100 col-sm-9 sp-pl0"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 center-block sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "vision-text col-sm-12 sp-pl0"
  }, [_c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Bank Details")]), _vm._v(" "), _c('p', [_vm._v("This account is where your payout would be sent to.")]), _vm._v(" "), (_vm.sellpoint.business_bank_details) ? _c('div', [(_vm.sellpoint.business_bank_details.length == 0 || _vm.set_bank_details) ? _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_name),
      expression: "sellpoint.business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_name),
      expression: "sellpoint.business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_bank_details.bank_account_number),
      expression: "sellpoint.business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.sellpoint.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("your details are securley saved")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.sellpoint.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('edit-bank-details', '')
      }
    }
  }, [_vm._v("Edit Bank Details")])])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set Processing Fee Option")]), _vm._v(" "), _c('p', [_vm._v("Each sale of an Item attracts a processing fee. The processng fee could\r\n                              be paid by you as you set your product, or by your customers as they buy. \r\n                              Processing Fees are subject to change.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Processing Fee is set to: 13% of your product Item")]), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 3) ? _c('span', [_vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay to your Custmers, notice this would increase the amount they pay on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(4)
      }
    }
  }, [_vm._v("Switch Pay to your Custmers")])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint.business_processing_fee_pay_status == 4) ? _c('span', [_vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("Switch Pay back to you, and let your Customers enjoy to pay only for their orders on checkout")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.switchProcessingFee(3)
      }
    }
  }, [_vm._v("Switch Pay Back to Me")])]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set your Sellpoint Filters")]), _vm._v(" "), _c('p', [_vm._v("This helps your customers to filter your products and services based on parameters like: categories, prices, colors, etc.")]), _vm._v(" "), (_vm.sellpoint.business_filters) ? _c('div', [_c('div', _vm._l((_vm.sellpoint.business_filters), function(bfilter) {
    return _c('p', [_vm._v("\r\n                                  " + _vm._s(bfilter.business_filter_name) + " "), _c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "padding": "0 3px 0 5px",
        "border-radius": "50%"
      },
      on: {
        "click": function($event) {
          _vm.removeFilterOption(bfilter.business_filter_id)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_vm._l((_vm.filters), function(filter) {
    return _c('label', {
      staticStyle: {
        "margin": "3px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_filters),
        expression: "selected_filters"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": filter.filter_id,
        "checked": Array.isArray(_vm.selected_filters) ? _vm._i(_vm.selected_filters, filter.filter_id) > -1 : (_vm.selected_filters)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected_filters,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter.filter_id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected_filters = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected_filters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected_filters = $$c
          }
        }
      }
    }), _vm._v(_vm._s(filter.filter_name) + "\r\n                                ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.setFilterOptions
    }
  }, [_vm._v("Save Filter Options")])], 2)]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                              You can set individual Product Discounts on thier product pages.\r\n                            ")]), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('span', [(_vm.setDiscount) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('view-discounts', '')
      }
    }
  }, [_vm._v("View your Discounts")]) : _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), _c('br'), _c('br')]) : _c('span', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an Ongoing discount, You can only set coupons. if you want to discontinue\r\n                                running discount, click on De-Activate and then set a new one")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-discount', '')
      }
    }
  }, [_vm._v("Set New Coupon")])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active != 1) ? _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-discount-coupon', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(17)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('li', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form_control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.setComponentActions('reset-discount-coupon', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.viewDiscounts && _vm.sellpoint.business_discounts_coupons) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), (dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponentActions('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                      Edit Coupon")]), _vm._v("    \r\n                                    "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                      Deactivate Coupon")])]) : _vm._e(), _vm._v(" "), _c('hr')])
  })], 2) : _vm._e()])])])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "notificationsModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(notification.notification_date))]), _c('br'), _vm._v("\r\n                  " + _vm._s(notification.notification_message))]), _vm._v(" "), _c('hr')])
  })), _vm._v(" "), _vm._m(19)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "menuModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loggedIn) ? _c('ul', {
    staticClass: "sp-menu-list"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "href": "account"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name) + ". view account")])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24)]) : _c('ul', {
    staticClass: "sp-menu-list"
  }, [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Sellpoint Links")]), _vm._v(" "), _c('ul', {
    staticClass: "shop-cate"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProfilePanel', '')
      }
    }
  }, [_vm._v("My Portfolio")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spContactPanel', '')
      }
    }
  }, [_vm._v("Contact Me")])]), _vm._v(" "), (_vm.sellpoint.business_market_category_id == 0) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("My Shop")])]) : _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', '')
      }
    }
  }, [_vm._v("Shop")])]), _vm._v(" "), (_vm.edit_mode) ? _c('span', [(_vm.sellpoint.business_market_category_id != 0 && _vm.sellpoint.business_market_category_id != 1) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spProductsPanel', 'market')
      }
    }
  }, [_vm._v("My Sellpoints")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spDeliveryPanel', '')
      }
    }
  }, [_vm._v("Delivery Information")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('spSettingsPanel', '')
      }
    }
  }, [_vm._v("Settings")])])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "margin-top": "-7px"
    },
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Markets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left sp-search-menu"
  }, [_c('div', {
    staticClass: "sp-search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "  I'm looking for ...."
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#notificationsModal"
    }
  }, [_vm._v("Notifications")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#news"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('span', {
    staticClass: "product-num"
  }, [_vm._v("Showing your products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    attrs: {
      "title": "High to Low"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-left": "-9.2px"
    }
  }, [_c('a', {
    attrs: {
      "title": "Low to High"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" 10% "), _c('span', [_vm._v("OFF")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-post-actions"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-heart-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-comment-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-share-alt",
    staticStyle: {
      "color": "#ffffff",
      "text-shadow": "-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by Me ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Status:")]), _vm._v(" Paid by My Customers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form col-md-6"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                  If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                  button.\r\n                                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Notifications")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "border-bottom-color": "transparent",
      "margin-bottom": "2em"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "3em"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "cart"
    }
  }, [_vm._v("View Cart "), _c('i', {
    staticClass: "fa fa-shopping-cart"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "orders"
    }
  }, [_vm._v("My Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Log Out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "create"
    }
  }, [_vm._v("Create A Sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Register")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c384de"}!./src/pages/Dashboard/SellpointDashboard/template.html
// module id = 284
// module chunks = 0